var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.8498 9.93335L26.8832 4.91668C33.6332 2.66668 37.2998 6.35001 35.0665 13.1L30.0498 28.1333C26.6832 38.25 21.1498 38.25 17.7832 28.1333L16.2998 23.6667L11.8332 22.1833C1.73317 18.8333 1.73317 13.3167 11.8498 9.93335Z",
    fill: "#FF4378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2002 19.3834L26.5502 13.0167L20.2002 19.3834Z",
    fill: "#FF4378"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1999 20.6334C19.8833 20.6334 19.5666 20.5167 19.3166 20.2667C18.8333 19.7834 18.8333 18.9834 19.3166 18.5L25.6499 12.1334C26.1333 11.65 26.9333 11.65 27.4166 12.1334C27.8999 12.6167 27.8999 13.4167 27.4166 13.9L21.0833 20.2667C20.8333 20.5 20.5166 20.6334 20.1999 20.6334Z",
    fill: "#FF4378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send-2.08ac146d5865cf5d300c41eb01c20f99.svg";
export { ForwardRef as ReactComponent };